import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MainButton } from '../../form/FormElements';
import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import FormButtonsContainer from '../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import FormDragger from '../../../antd/form/FormDragger/FormDragger';
import FormButton from '../../../antd/form/FormButton/FormButton';
import useFileDraggerFileValidation from '../../../../hooks/useFileDraggerFileValidation';
import { useToastMessages } from '../../../../hooks/useToastMessages';
import FormTextField from '../../../antd/form/FormTextField/FormTextField';

const UploadForm = ({
  onFileUpload,
  onClose,
  allowedTypes = undefined,
  errorMessage = undefined,
  multiple = false,
  maxCount = 1,
  enableCustomFileName = false,
  initialText = '',
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { errorMessage: showErrorMessage } = useToastMessages();

  const setFileName = (value) => {
    form.setFieldsValue({ Text: value });
  };

  const { beforeUpload, onRemove, fileList, clearFileList } =
    useFileDraggerFileValidation(allowedTypes, errorMessage, maxCount);

  useEffect(() => {
    form.setFieldsValue({
      Text: initialText,
    });
  }, [initialText, form]);

  const finish = (values) => {
    if (fileList.length === 0) {
      showErrorMessage({
        message: 'Nie je možné nahrať prázdny súbor!',
      });
      return;
    }

    let fileProp;
    const customName = values.Text || null;

    if (maxCount > 1) {
      fileProp = fileList;
    } else {
      const file = fileList[0];
      if (customName) {
        const extension = '.' + file.name.split('.').pop();
        fileProp = new File([file], customName + extension, {
          type: file.type,
        });
      } else {
        fileProp = file;
      }
    }

    onFileUpload({ file: fileProp, customName: customName }, clearFileList);
  };

  return (
    <Form form={form} onFinish={finish}>
      {enableCustomFileName && (
        <>
          <label style={{ fontWeight: 'bold' }}>
            {t('Zobrazený text odkazu')}
          </label>
          <FormTextField
            className={'note-to-field'}
            name={'Text'}
            onChange={(e) => setFileName(e.target.value)}
          />
        </>
      )}
      <FormDragger
        label={t('Vybrať súbor')}
        name={'file'}
        multiple={multiple}
        maxCount={maxCount}
        beforeUpload={beforeUpload}
        fileList={fileList}
        onRemove={onRemove}
        listType="picture"
      />
      <FormButtonsContainer>
        {onClose && (
          <MainButton onClick={() => onClose()}>{t('Zrušiť')}</MainButton>
        )}
        <FormButton submitOnClick={true} size="large">
          {t('Nahrať')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

UploadForm.propTypes = {
  onFileUpload: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  onClose: PropTypes.any,
  allowedTypes: PropTypes.arrayOf(PropTypes.string),
  apiErrorMessage: PropTypes.func,
  maxCount: PropTypes.number,
  enableCustomFileName: PropTypes.bool,
  initialText: PropTypes.string,
};

export default UploadForm;
